import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, BootstrapVueIcons  } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
import VueTheMask from "vue-the-mask";
import VueBootstrapAutocomplete from "@vue-bootstrap-components/vue-bootstrap-autocomplete";
import moment from "moment/moment";
import VueMask, { VueMaskFilter } from "v-mask";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import setaAxios  from "./service/Axios.js";
import fileUtils  from "../src/utils/FileUtils.js";

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("vue-autocomplete", VueBootstrapAutocomplete);
Vue.config.productionTip = false;

Vue.use(VueMask);

Vue.filter("VMask", VueMaskFilter);

Vue.filter("moment", moment);

Vue.prototype.$fileUtils = fileUtils;

const usuario = JSON.parse(localStorage.getItem("usuario"));

router.beforeEach((to, from, next) => {
	setaAxios();
	// TODO método que irá verificar se o token é valido.
	if ((to.meta.requiresAuth && !localStorage.getItem("usuario"))) {
		next("/login");
	} else {
		next();
	}
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.filter("addMascara", (value, type) => {
	let expression = "";

	switch (type) {
	case "cbo":
		expression = value.replace(/^(\d{2})(\d{2})(\d{2})$/, "$1.$2-$3");
		return expression;

	case "cpf":
		expression = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
		return expression;

	case "cnpj":
		expression = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
		return expression;

	case "cep":
		expression = value.replace(/\D/g, "").replace(/([0-9]{5})([0-9]{3})/, "$1-$2");
		return expression;

	case "tel":
		expression = value.replace(/\D/g, "");

		if (expression.length > 2) {
		  expression = expression.replace(/^(\d{2})(\d{1,5})/, "($1) $2");
		}

		if (expression.length > 7) {
		  expression = expression.replace(/(\d{4,5})(\d{4})$/, "$1-$2");
		} else if (expression.length > 2) {
		  expression = expression.replace(/(\d{4})(\d{0,4})$/, "$1-$2");
		}


		return expression;
	default:
		return expression;
	}
});

Vue.filter("removeMascara", (value) => {
	if (value === undefined || value === null) {
		return "";
	}
	return value.replace(/\D+/g, "");
});

Vue.filter("checkPermissao", () => usuario.permissoes[0]);
Vue.use(VueTheMask);

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	components: { App },
	template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js